import { useState, useEffect } from 'react';
import { ArrowIcon } from './Icons';

export interface LiveStreamData {
  isLive: boolean;
  id?: string;
  title?: string;
  creator?: string;
  thumbnail?: string;
  url?: string;
}

export function LiveBanner({ onOpenModal }: { onOpenModal?: (video: any) => void }) {
  const [liveData, setLiveData] = useState<LiveStreamData | null>(null);

  useEffect(() => {
    const fetchLive = () => {
      fetch('/api/live')
        .then((res) => res.json())
        .then((data: LiveStreamData) => {
          if (data && data.isLive) {
            setLiveData(data);
          } else {
            setLiveData(null);
          }
        })
        .catch(() => setLiveData(null));
    };

    fetchLive();
    const timer = setInterval(fetchLive, 45_000); // Poll every 45s
    return () => clearInterval(timer);
  }, []);

  if (!liveData || !liveData.isLive) {
    return null;
  }

  return (
    <div className="live-broadcast-banner" role="banner" aria-label="Active YouTube Live Stream">
      <div className="live-banner-content">
        <div className="live-badge-glow">
          <span className="live-dot-pulse" />
          <b>LIVE NOW</b>
        </div>
        <div className="live-banner-text">
          <span className="live-creator-label">{liveData.creator || 'Uge Appage SMP'}:</span>
          <span className="live-stream-title" title={liveData.title}>{liveData.title}</span>
        </div>
      </div>
      <div className="live-banner-actions">
        {onOpenModal ? (
          <button
            className="live-watch-btn"
            onClick={() => onOpenModal(liveData)}
          >
            <span>Watch Live</span>
            <ArrowIcon />
          </button>
        ) : (
          <a
            href={liveData.url || `https://www.youtube.com/watch?v=${liveData.id}`}
            target="_blank"
            rel="noreferrer"
            className="live-watch-btn"
          >
            <span>Watch Live</span>
            <ArrowIcon />
          </a>
        )}
      </div>
    </div>
  );
}
